var map = {
	"./app.png": 1264,
	"./calendar.png": 7939,
	"./draft-apps.svg": 3986,
	"./e-icon.png": 1082,
	"./eclipse.png": 2223,
	"./eoffice.png": 2184,
	"./graph.png": 807,
	"./gws.png": 8185,
	"./imac.png": 6284,
	"./logo.png": 1877,
	"./user.svg": 9124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7810;